import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const Close: React.FC<CommonPropTypes> = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='9'
      height='10'
      viewBox='0 0 9 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 1.36724L5.73076 4.99973L9 8.63223L7.76901 10L4.49976 6.3675L1.23052 10L1.76416e-06 8.63223L3.26877 4.99973L1.76416e-06 1.36724L1.23052 -1.21765e-06L4.49976 3.63196L7.76901 -1.21765e-06L9 1.36724Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Close;
